var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Breadcrumbs from "../../App/components/Breadcrumbs";
import Title from "../../App/components/Title";
import Notification from "../../App/components/Notification";
import ModalInvoice from "../components/ModalInvoice";
import "../styles/BillingDetail.css";
import CircularProgress from '@mui/material/CircularProgress';
import BillingService from "../services/BillingService";
function BillingLicensesDetail() {
    var _a;
    var location = useLocation();
    var billing_id = useParams().billing_id;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), billingLicenseData = _c[0], setBillingLicenseData = _c[1];
    var _d = useState([]), invoices = _d[0], setInvoices = _d[1];
    var _e = useState([]), customerLicenses = _e[0], setCustomerLicenses = _e[1];
    var _f = useState([]), details = _f[0], setDetails = _f[1];
    var _g = useState(false), showModalInvoice = _g[0], setShowModalInvoice = _g[1];
    var _h = useState('#'), nfse_link = _h[0], setNfseLink = _h[1];
    var _j = useState('#'), xml_link = _j[0], setXmlLink = _j[1];
    var prod_url = process.env.REACT_APP_STORAGE_URL;
    useEffect(function () {
        if (billing_id) {
            getBillingResume(Number(billing_id));
        }
    }, [billing_id]);
    function cleanPath(p) {
        if (!p)
            return null;
        return p.replace(/^['"]+|['"]+$/g, '').trim();
    }
    function makeUrl(p) {
        var cleaned = cleanPath(p);
        if (!cleaned)
            return '#';
        if (/^https?:\/\//i.test(cleaned) || cleaned.includes('focusnfe')) {
            return cleaned;
        }
        if (!prod_url) {
            return cleaned;
        }
        var base = prod_url.replace(/\/$/, '');
        return cleaned.startsWith('/') ? "".concat(base).concat(cleaned) : "".concat(base, "/").concat(cleaned);
    }
    function getBillingResume(billingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Block.circle("[data-id=billing-grid]");
                BillingService.getInvoices(billingId).then(function (res) {
                    setBillingLicenseData(res.data.billing_license);
                    setInvoices(res.data.invoices);
                    setCustomerLicenses(res.data.customer_licenses || []);
                    setDetails(res.data.details || []);
                    setLoading(false);
                    if (res.data.invoices.length > 0) {
                        var invoice = res.data.invoices[0];
                        setNfseLink(makeUrl(invoice.pdf_path));
                        setXmlLink(makeUrl(invoice.xml_path));
                    }
                }, function (err) {
                    if (err.response.status === 403) {
                        Notification().Notify.failure("Usuário não tem permissão para visualizar essa página!");
                    }
                    else {
                        Notification().Notify.failure(err.message);
                    }
                    setLoading(false);
                });
                Notification().Block.remove("[data-id=billing-grid]");
                return [2 /*return*/];
            });
        });
    }
    ;
    function getBankSlip(id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Notification().Block.circle("[data-id=payment-links]");
                        return [4 /*yield*/, BillingService.getBankSlipLicense(id).then(function (res) {
                                Notification().Block.remove("[data-id=payment-links]");
                                var file = new Blob([res.data]);
                                var url = window.URL.createObjectURL(file);
                                var tempLink = document.createElement("a");
                                tempLink.href = url;
                                tempLink.setAttribute("target", "_blank");
                                tempLink.setAttribute("download", "boleto.pdf");
                                document.body.appendChild(tempLink);
                                tempLink.click();
                                document.body.removeChild(tempLink);
                                window.URL.revokeObjectURL(res.data.bank_slip);
                            }, function (err) {
                                Notification().Block.remove("[data-id=payment-links]");
                                if (err.response.status === 422 || err.response.status === 500) {
                                    var data = JSON.parse(new TextDecoder().decode(err.response.data));
                                    Notification().Notify.failure(data.error);
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    var breadcrumbsItens = [
        {
            name: "Minhas faturas",
            route: "/billings"
        },
        {
            name: "Detalhes da fatura",
            route: "/billing-licenses/".concat(billing_id)
        }
    ];
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsx(Title, { text: "Detalhes da fatura", variableText: (_a = location.state) === null || _a === void 0 ? void 0 : _a.referenceDates, style: { color: 'gray' }, hr: false }), _jsx(Breadcrumbs, { itens: breadcrumbsItens }), _jsx("div", __assign({ className: "container-billing-detail", "data-id": "billing-grid" }, { children: loading ? (_jsx("div", __assign({ style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "1rem"
                    }, className: "card-total-invoice" }, { children: _jsx(CircularProgress, {}) }))) : (_jsxs("div", __assign({ className: "container-total-invoice", "data-id": "billing-links" }, { children: [_jsx("div", __assign({ className: "billing-buttons" }, { children: _jsxs("div", { children: [_jsx("button", __assign({ className: "blue-button", style: { width: "83px", height: "42px" }, onClick: function () { return getBankSlip(Number(billing_id)); } }, { children: "Pagar" })), _jsx("button", __assign({ className: "button-with-blue-border", style: { width: "122px", height: "42px" }, onClick: function () { return setShowModalInvoice(true); } }, { children: "Nota fiscal" }))] }) })), _jsx("div", __assign({ className: "card-total-invoice" }, { children: _jsxs("div", __assign({ className: "pl-4 card-total" }, { children: [_jsx("p", __assign({ className: "title-billing-detail" }, { children: "Total a pagar" })), _jsxs("p", __assign({ id: "total-payable" }, { children: ["R$ ", billingLicenseData === null || billingLicenseData === void 0 ? void 0 : billingLicenseData.total.toLocaleString('pt-BR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })] }))] })) }))] }))) })), _jsxs("table", __assign({ className: "default-table-styling", "data-id": "billing-grid" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Tipo" }), _jsx("th", { children: "Produto" }), _jsx("th", { children: "Marca" }), _jsx("th", { children: "Fonte" }), _jsx("th", { children: "Total" })] }) }), _jsx("tbody", { children: details.map(function (detail) {
                            var license = customerLicenses.find(function (cl) { return cl.id === detail.customer_license_id; });
                            if (!license) {
                                console.warn("License n\u00E3o encontrada para customer_license_id: ".concat(detail.customer_license_id));
                                return null;
                            }
                            return (_jsxs("tr", { children: [_jsx("td", { children: "Licen\u00E7a" }), _jsx("td", { children: "CDN" }), _jsx("td", { children: license.brand }), _jsx("td", { children: license.power_supply }), _jsxs("td", { children: ["R$ ", Number(detail.price).toLocaleString("pt-BR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })] })] }, detail.id));
                        }) })] })), _jsx(ModalInvoice, { show: showModalInvoice, closeModal: function () { return setShowModalInvoice(false); }, nfse_link: nfse_link, xml_link: xml_link })] })));
}
export default BillingLicensesDetail;
